module.exports = __webpack_public_path__ + "assets/img/pasted.d5cf6598.png";